// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container_1PLyK","chevron":"Detail_chevron_1feYU","usersTable":"Detail_usersTable_3dg5u"};